import { API_PATH } from '@/shared/constants/api'
import { apiRequest } from '@/shared/helpers/api-request'
import { getJwt } from '@/shared/lib/betterAuth/get-jwt'
import type { Pet, PetBreed, PetVet } from '@/shared/types/global.types'

export type PetUpdateBody = Partial<Omit<Pet, 'id' | 'petPictureUrl'>> & {
  petPicture?: {
    fileInBase64: string
    fileExtension: string
  }
}

export function getPets(token: string): Promise<Pet[]> {
  return apiRequest<Pet[]>(API_PATH.PETS, token)
}

export async function updatePet(
  petId: number,
  body: PetUpdateBody,
): Promise<Pet> {
  const token = await getJwt()
  if (!token) throw new Error('No JWT token')
  return apiRequest<Pet>(`${API_PATH.PETS}/${petId}`, token, 'PATCH', body)
}

export async function getPetBreeds(token: string): Promise<PetBreed[]> {
  const res = await apiRequest<{ results: PetBreed[] }>(
    `${API_PATH.PET_BREEDS}?totalPerPage=500`,
    token,
  )
  return Array.isArray(res?.results) ? res.results : []
}

export async function getPetVets(
  token: string,
  name: string,
): Promise<PetVet[]> {
  const res = await apiRequest<{ results: PetVet[] }>(
    `${API_PATH.PET_VETS}?name=${encodeURIComponent(name)}&totalPerPage=500&page=1`,
    token,
  )
  return Array.isArray(res?.results) ? res.results : []
}
